/**
 * markup.ts — HTML do splash + jogo, injetado no #app em runtime.
 *
 * Separado em funcao pura pra deixar Game.ts enxuto. Os IDs sao iguais aos
 * do tres.php pra manter equivalencia 1:1 com o legado.
 */

export function markupJogo(): string {
  return `
    <!-- ============= SPLASH ============= -->
    <div class="sw-splash" id="swSplash">
      <div class="sw-estrelas"></div>
      <div class="sw-glow"></div>

      <div class="sw-card">
        <div class="sw-logo-orbit">
          <div class="sw-orbita"></div>
          <div class="sw-orbita sw-orbita-2"></div>
          <div class="sw-logo-fallback"></div>
        </div>

        <h1 class="sw-titulo">SpaceWar</h1>
        <p class="sw-subtitulo">Conquista Espacial Multiplayer</p>

        <div class="sw-status" id="swStatus">
          <div class="sw-status-linha aguardando" id="swStatusToken">
            <span class="sw-status-icone aguardando">&#x25cb;</span>
            <span>Gerando credenciais de sessao...</span>
          </div>
          <div class="sw-status-linha aguardando" id="swStatusConexao" style="display:none">
            <span class="sw-status-icone aguardando">&#x25cb;</span>
            <span>Conectando ao servidor de jogo...</span>
          </div>
          <div class="sw-status-linha aguardando" id="swStatusAuth" style="display:none">
            <span class="sw-status-icone aguardando">&#x25cb;</span>
            <span>Autenticando...</span>
          </div>
          <div class="sw-status-linha aguardando" id="swStatusPartida" style="display:none">
            <span class="sw-status-icone aguardando">&#x25cb;</span>
            <span>Carregando mapa...</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ============= JOGO ============= -->
    <div class="sw-jogo" id="swJogo">
      <div id="swPixiContainer"></div>

      <a href="/" class="sw-voltar">&larr; Sair</a>

      <div class="sw-hud">
        <div class="sw-hud-card sw-hud-jogador">
          <span class="sw-hud-cor" id="swCor"></span>
          <div>
            <div class="sw-hud-titulo">Comandante</div>
            <div class="sw-hud-valor" id="swNomeJogador">--</div>
          </div>
        </div>

        <div class="sw-hud-card">
          <div class="sw-hud-titulo">Tempo</div>
          <div class="sw-hud-valor sw-hud-tempo" id="swTempo">--:--</div>
        </div>

        <div class="sw-hud-card">
          <div class="sw-hud-titulo">Planetas</div>
          <div class="sw-hud-valor"><span id="swPlanetasTotal">0</span> total · <span id="swPlanetasMeus">0</span> seus</div>
        </div>

        <div class="sw-hud-card" id="swHudConstelacao" style="display:none">
          <div class="sw-hud-titulo">Constelacao</div>
          <div class="sw-hud-valor" id="swConstelacaoValor">--</div>
        </div>

        <div class="sw-hud-card">
          <div class="sw-hud-titulo">Naves</div>
          <div class="sw-hud-valor"><span id="swNavesMinhas">0</span> orbitando · <span id="swNavesMortas">0</span> mortas</div>
        </div>

        <div class="sw-hud-card sw-hud-envio">
          <div class="sw-hud-titulo">Envio rapido</div>
          <div class="sw-hud-valor" id="swEnvio">50%</div>
        </div>
      </div>

      <!-- Retangulo de selecao (shift+arrastar) -->
      <div class="sw-retangulo" id="swRetangulo"></div>

      <!-- Barra de toque: percentual do envio, todos, varios -->
      <div class="sw-barra" id="swBarra">
        <button class="sw-chip" type="button" data-pct="0.25">25%</button>
        <button class="sw-chip ativo" type="button" data-pct="0.5">50%</button>
        <button class="sw-chip" type="button" data-pct="0.75">75%</button>
        <button class="sw-chip" type="button" data-pct="1">100%</button>
        <span class="sw-barra-sep"></span>
        <button class="sw-chip" type="button" id="swBtnTodos" title="Selecionar todos os seus planetas (A)">Todos</button>
        <button class="sw-chip" type="button" id="swBtnMulti" title="Cada toque soma um planeta a selecao">Varios</button>
      </div>

      <div class="sw-aviso" id="swAviso"></div>

      <div class="sw-minimapa" id="swMinimapa">
        <canvas id="swMinimapaCanvas" width="200" height="200"></canvas>
        <div class="sw-minimapa-label">Minimapa</div>
      </div>

      <div class="sw-controles">
        <div><kbd>click</kbd> planeta seu = origem · <kbd>shift+click</kbd> soma · <kbd>shift+arrastar</kbd> varios · <kbd>A</kbd> todos</div>
        <div><kbd>click no alvo</kbd> enviar · <kbd>botao direito</kbd> envio rapido · <kbd>1 2 3 4</kbd> 25/50/75/100%</div>
        <div><kbd>arrastar</kbd> camera · <kbd>scroll</kbd> zoom · <kbd>m</kbd> centralizar · <kbd>esc</kbd> cancelar</div>
      </div>

      <!-- Dialog de lancamento -->
      <div class="sw-dialog-lancar" id="swDialogLancar">
        <div class="sw-dialog-titulo">Enviar frota</div>
        <div class="sw-dialog-rota">
          <span id="swDialogOrigem">--</span>
          <span class="sw-dialog-arrow">&rarr;</span>
          <span id="swDialogDestino">--</span>
        </div>
        <div class="sw-dialog-slider-row">
          <input type="range" class="sw-dialog-slider" id="swDialogSlider" min="1" max="100" value="50">
          <span class="sw-dialog-qtd" id="swDialogQtd">50</span>
        </div>
        <div class="sw-dialog-pcts">
          <button class="sw-dialog-pct-btn" data-pct="0.25">25%</button>
          <button class="sw-dialog-pct-btn" data-pct="0.50">50%</button>
          <button class="sw-dialog-pct-btn" data-pct="0.75">75%</button>
          <button class="sw-dialog-pct-btn" data-pct="1.00">100%</button>
        </div>
        <div class="sw-dialog-acoes">
          <button class="sw-dialog-btn sw-dialog-btn-cancelar" id="swDialogCancelar">Cancelar</button>
          <button class="sw-dialog-btn" id="swDialogEnviar">Enviar</button>
        </div>
      </div>

      <!-- Botao flutuante de construir torre -->
      <button class="sw-botao-torre" id="swBotaoTorre" type="button">
        <span class="sw-botao-torre-icone">&#x1F3D7;</span>
        <span>Construir Torre</span>
        <span class="sw-botao-torre-custo" id="swBotaoTorreCusto">(5)</span>
      </button>

      <!-- Overlay de fim de partida -->
      <div class="sw-fim" id="swFim">
        <div class="sw-fim-card" id="swFimCard">
          <h2 class="sw-fim-titulo" id="swFimTitulo">Fim</h2>
          <div class="sw-fim-motivo" id="swFimMotivo">--</div>
          <div class="sw-fim-stats">
            <div>Duracao<strong id="swFimDuracao">--</strong></div>
            <div>Jogadores<strong id="swFimJogadores">--</strong></div>
          </div>
          <ol class="sw-fim-ranking" id="swFimRanking"></ol>
          <div class="sw-fim-acoes">
            <a class="sw-fim-btn sw-fim-btn-secundario" href="/">Sair</a>
            <button class="sw-fim-btn" id="swFimJogarNovamente" type="button">Jogar Novamente</button>
          </div>
        </div>
      </div>
    </div>
  `;
}
